import script from "./aiorder_view.vue?vue&type=script&setup=true&lang=js"
export * from "./aiorder_view.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__